import { useMutation } from '@tanstack/react-query';
import { ShopOnboardingID } from '@prisma/client';
import { UpdateBusinessPayload } from '../../types/businesses';
import { handleUpdateBusiness } from '../../helpers/businesses';
import { Business } from '../../interfaces';
import useUser from '../global/useUser';
import useGetOnboarding from './useGetOnboarding';

interface Options {
  onSuccess?: (result: Business | null) => void | Promise<void>;
  step?: ShopOnboardingID;
}

function useUpdateBusiness({ onSuccess, step }: Options = {}) {
  const { user, reloadUser } = useUser();
  const { reloadAfterUpdate } = useGetOnboarding();

  return useMutation({
    mutationFn: async (payload: UpdateBusinessPayload) => {
      if (!user?.business?.id) return null;
      const result = await handleUpdateBusiness(user.business.id, payload);
      return result;
    },
    onSuccess: async result => {
      if (!result) return;
      reloadAfterUpdate(step || 'SHOP_SETTINGS');
      await reloadUser();
      await onSuccess?.(result);
    },
  });
}

export default useUpdateBusiness;
